import styled from 'styled-components'

export const UploaderContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 150px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
  background: rgba(158, 216, 177, 0.1);
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23008755FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='3' stroke-linecap='square'/%3e%3c/svg%3e");
  cursor: ${(props) => (props.isReadyForUpload ? 'pointer' : 'default')};

  &.active,
  &:hover {
    ${(props) => (props.isReadyForUpload ? 'background: #9ed8b1;' : '')}
  }

  & .mobile-only {
    @media only screen and (min-width: ${(props) => props.theme.tablet}) {
      display: none;
    }
  }

  & .browse-file {
    margin-bottom: 0;
    color: #008755;
    font-family: 'AnPostSansBold', sans-serif;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    text-decoration-line: underline;

    @media only screen and (min-width: ${(props) => props.theme.tablet}) {
      padding: 1.4rem 2.4rem;
      color: #1b1e1c;
      border: 1px solid #003d4c;
      border-radius: 6px;
      text-decoration-line: none;
    }
  }
  .measurements {
    margin-top: 2.4rem;
    font-size: 1.4rem;
  }
`

export const Uploader = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const CloudIconContainer = styled.div`
  display: none;

  @media only screen and (min-width: 900px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      margin-bottom: 0;
      font-size: 1.6rem;

      &.file-type {
        font-size: 1.2rem;
      }
      &.operator {
        margin: 2.4rem 0;
      }
    }
  }
`

export const CloudImage = styled.img`
  display: none;

  @media only screen and (min-width: ${(props) => props.theme.tablet}) {
    display: block;
    width: 3.6rem;
    height: 3.6rem;
  }
`

export const UploadingProgress = styled.div`
  display: flex;
  gap: 1.2rem;
  min-width: 20rem;
`

export const FileImage = styled.img`
  display: block;
  width: 2.4rem;
  height: 2.4rem;

  @media only screen and (min-width: ${(props) => props.theme.tablet}) {
    width: 3.4rem;
    height: 3.4rem;
  }
`

export const Uploading = styled.p`
  margin-bottom: 0;
`

export const ProgressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
`

export const Progress = styled.div`
  flex: 1;
  position: relative;
  height: 0.8rem;
  background: #cfd0cf;
  border-radius: 8px;
`

export const ProgressBar = styled.div`
  position: absolute;
  height: 100%;
  width: ${(props) => props.$progress}%;
  background: #00a76a;
  border-radius: 8px;
  transition: width 0.3s ease-in-out;
`

export const CancelButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  gap: 0.6rem;

  p {
    font-size: 1.4rem;
    font-family: AnPostSansBold, sans-serif;
    font-weight: 700;
  }
`

export const CancelImage = styled.img`
  display: block;
  width: 1.6rem;
  height: 1.6rem;
`

export const UploadCompletedContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.6rem',
  'div:first-child': {
    display: 'flex',
    gap: '1.6rem',
    div: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0,
    },
    p: {
      marginBottom: 0,
      fontSize: '1.2rem',
      lineHeight: '2rem',
    },
    'p:nth-child(2)': {
      fontWeight: 700,
    },
  },
  'div:nth-child(2)': {
    display: 'flex',
    gap: '3.2rem',
    button: {
      fontWeight: 700,
      fontSize: '1.4rem',
      lineHeight: '2rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      color: '#3D4543',
    },
    'button:nth-child(2)': {
      color: '#008755',
    },
  },
})

export const CenteredContainer = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
